<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Action Types</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="editActionType"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            >
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />

        <div class="vx-row p-5" v-if="actionTypeDescription.name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Name:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ actionTypeDescription.name }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="actionTypeDescription.description">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Description:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ actionTypeDescription.description }}
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import defineAbilitiesFor from "@/config/abilities";
import _ from "lodash";
import moduleActionTypeManagement from "@/store/action-type-management/moduleActionTypeManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
      configDateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
      abilities: null,
      actionTypeDescription: [],
      action_type_id: null
    };
  },
  components: {
    "v-select": vSelect,
    moduleActionTypeManagement,
        flatPickr

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleActionTypeManagement.isRegistered) {
      this.$store.registerModule(
        "ActionTypesManagement",
        moduleActionTypeManagement
      );
      moduleActionTypeManagement.isRegistered = true;
    }
  },
  mounted() {
    this.action_type_id = this.$route.params.action_typeId;
    this.fetchActionType();
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    fetchActionType() {
      this.$store
        .dispatch("ActionTypesManagement/fetchActionTypes", this.action_type_id)
        .then(res => {
          let result = JSON.parse(res.data);
          this.actionTypeDescription = result[0]
          // console.log(this.actionTypeDescription[0])
        })
        .catch(err => {
          console.error(err);
        });
    },
    editActionType() {
      this.$router.push({ path: `/audit_trial/action_type/edit/${this.action_type_id}` });
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
